import { useState, useCallback, ChangeEvent } from 'react';
import { useAppDispatch } from '../../../store/store';
import {
  addBlacklistNumber,
  BlockRequest,
} from '../../../store/reducers/BlacklistPopupSlice';
import { ReasonTypes } from '../../components/useBlacklist/types';

export const useBlacklistPopup = () => {
  const dispatch = useAppDispatch();

  const [phone, setPhone] = useState<string>('');
  const setPhoneValue = useCallback((digits: string) => {
    setPhone(digits);
  }, []);

  const [comment, setComment] = useState<string>('');
  const setCommentValue = (event: ChangeEvent<HTMLInputElement>) => {
    setComment(event.target.value);
  };
  const [selectedReason, setSelectedReason] = useState<
    ReasonTypes | null | undefined
  >(null);

  const handleReset = useCallback(() => {
    setPhone('');
    setComment('');
    setSelectedReason(null);
  }, []);

  const handleOk = useCallback(() => {
    const blockRequest: BlockRequest = {
      useForInbound: true,
      useForOutbound: true,
      comment: comment || undefined,
      reason: selectedReason,
      phone,
    };

    return dispatch(addBlacklistNumber(blockRequest));
  }, [dispatch, phone, selectedReason, comment]);

  return {
    phone,
    comment,
    selectedReason,
    onPhoneChange: setPhoneValue,
    onCommentChange: setCommentValue,
    onSelectedReasonChange: setSelectedReason,
    handleOk,
    handleReset,
  };
};
